import React from 'react';

interface AvatarProps {
  email: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const Avatar: React.FC<AvatarProps> = ({ email, size = 'md', className = '' }) => {
  // Generate avatar initials
  const getInitials = (email: string) => {
    const username = email.split('@')[0];
    return username.charAt(0).toUpperCase();
  };

  // Generate consistent color based on email
  const getAvatarColor = (email: string) => {
    const colors = [
      'bg-blue-500', 'bg-green-500', 'bg-purple-500', 'bg-pink-500',
      'bg-indigo-500', 'bg-yellow-500', 'bg-red-500', 'bg-teal-500',
      'bg-orange-500', 'bg-cyan-500', 'bg-emerald-500', 'bg-violet-500'
    ];
    
    // Create hash from email for consistent color selection
    const hash = email.split('').reduce((a, b) => {
      a = ((a << 5) - a + b.charCodeAt(0)) & 0xffffffff;
      return a;
    }, 0);
    
    return colors[Math.abs(hash) % colors.length];
  };

  // Size classes
  const sizeClasses = {
    sm: 'h-6 w-6 text-xs',
    md: 'h-10 w-10 text-sm',
    lg: 'h-12 w-12 text-base',
    xl: 'h-16 w-16 text-lg'
  };

  return (
    <div 
      className={`
        ${sizeClasses[size]} 
        ${getAvatarColor(email)} 
        rounded-full 
        flex 
        items-center 
        justify-center 
        text-white 
        font-semibold 
        shadow-sm
        ring-2
        ring-white
        ${className}
      `}
    >
      {getInitials(email)}
    </div>
  );
};

export default Avatar;

